<template>
  <div>
    <div class="comments-form">
      <div>
        <at
          :members="members"
          v-model="comment"
          name-key="name"
          @insert="handleAddNotif"
        >
          <template slot="item" slot-scope="s">
            <span v-text="s.item.name"></span>
          </template>
          <template v-slot:embeddedItem="s">
            <span><span class="tagLink">@{{ s.current.name }}</span></span>
          </template>
          <div
            contenteditable="true"
            ref="commentInput"
            class="comments-input"
            :placeholder=" isResponse ? 'Ma réponse...' : 'Mon commentaire...'"
            @blur="handleBlur"
          ></div>
        </at>

        <div class="row-btn ">
          <b-button
          v-if="isResponse"
          class="btn btn-send"
          @click="handleBtnSendClick"
          ><font-awesome-icon :icon="['far', 'paper-plane']" />
          Répondre</b-button
          >
          <b-button
            v-else-if="isEdit"
            class="btn btn-send"
            @click="handleBtnSendClick"
            ><font-awesome-icon :icon="['far', 'paper-plane']" /> Editer</b-button
          >
          <b-button v-else class="btn btn-send" @click="handleBtnSendClick"
            ><font-awesome-icon :icon="['far', 'paper-plane']" />
            Envoyer</b-button
          >

          <div class="delete-all text-right" v-if="!modeVue">
            <button class="btn btn-delete" @click.prevent="handleDeleteAllCom">
              Supprimer tous les commentaires
            </button>
          </div>
        </div>

      </div>
    </div>

    <!-- confirmation modal -->
    <b-modal
      id="modal-confirmation"
      title="Confirmation"
      ref="confirmationModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @ok="handleOkDeleteAll"
      :modal-class="'base-modal'"
      cancel-variant="outline-primary"
      cancel-title="Annuler"
    >
      <p>Êtes-vous certain de vouloir supprimer tous les commentaires?</p>
    </b-modal>
    <!-- /confirmation modal -->

    <contenu-comments
      v-if="this.isLoadedComments"
      :comments="commentsList"
      @onRespond="handleOnRespond"
      @deleteOk="reloadCommentsList"
      @editCom="handleEditComment"
      :mode-vue="modeVue"
    ></contenu-comments>
  </div>
</template>

<script>
import At from 'vue-at'
import contenuComments from './contenu'
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    modeVue: {
      type: Boolean,
      default: false
    }
  },
  components: {
    contenuComments,
    At
  },
  data () {
    return {
      comment: '',
      commentsList: null,
      commentParent: null,
      notifications: [],
      members: [],
      isEdit: false,
      commentId: null,
      isResponse: false
    }
  },
  mounted () {
    this.setCommentsList(this.typeModule(), this.entityId)
    if (!this.modeVue) {
      this.setMembers(this.userSocieteId())
    }
  },
  computed: mapGetters(['comments', 'isLoadedComments', 'entityId', 'isLoadedEntityId']),
  watch: {
    comments (newValue) {
      this.commentsList = newValue
    },
    $route (to, from) {
      if (to.name === 'specification_technique' || to.name === 'cahier_environnemental') {
        this.setCommentsList(this.typeModule(), this.entityId)
        this.setMembers(this.userSocieteId())
      }
    },
    async entityId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.setIsLoadedComments(false)
        await this.setCommentsList(this.typeModule(), newValue)
        this.setIsLoadedComments(true)
      }
    }
  },
  methods: {
    ...mapGetters(['typeModule', 'currentOnglet', 'userSocieteId']),
    ...mapActions(['setMessage', 'deleteAllComments', 'addComments', 'getComments', 'getUsersByClientId', 'setIsLoadedComments', 'modifyComments']),
    handleBlur () {
      if (this.comment === '') {
        this.isResponse = false
      }
    },
    async handleBtnSendClick () {
      let data = {}
      const mode = this.modeVue
      if (!this.isResponse) {
        data = {
          commentaire: this.comment,
          type: this.typeModule(),
          parent: null,
          notifications: this.notifications,
          entite: this.entityId
        }
      } else {
        data = {
          commentaire: this.comment,
          type: this.typeModule(),
          parent: this.commentParent,
          notifications: this.notifications,
          entite: this.entityId
        }
        this.isResponse = false
      }

      const payload = {
        data: data,
        mode
      }

      if (this.comment !== '' && !this.isEdit) {
        await this.addComments(payload)
        this.comment = ''
        return
      }

      if (this.isEdit) {
        await this.modifyComments({ mode: mode, id: this.commentId, data })
        this.comment = ''
        this.isEdit = false
      }
    },
    handleOnRespond (id) {
      this.commentParent = id
      this.isResponse = true
      this.comment = ''
      this.isEdit = false
      this.$refs.commentInput.focus()
    },
    handleAddNotif (item) {
      this.notifications.push(item.id)
    },
    async setCommentsList (type, entity) {
      const mode = this.modeVue
      console.log('entity', type)
      await this.getComments({ mode, type, entity })
      this.commentsList = this.comments
      this.setIsLoadedComments(true)
    },
    async reloadCommentsList () {
      await this.setCommentsList(this.typeModule(), this.entityId)
    },
    handleEditComment (comment) {
      if (comment.parent !== null) {
        this.isResponse = true
      }
      this.comment = comment.commentaire
      this.isEdit = true
      this.commentId = comment.id
      this.$refs.commentInput.focus()
    },
    handleDeleteAllCom () {
      this.$refs.confirmationModal.show()
    },
    async handleOkDeleteAll () {
      await this.deleteAllComments({ type: this.typeModule(), entity: this.entityId })
      this.setMessage('Supprimé')
      this.commentsList = null
    },
    async setMembers (userSocieteId) {
      this.members = await this.getUsersByClientId(userSocieteId)
      this.members = this.members.map(member => {
        return {
          id: member.id,
          name: member.nom + '_' + member.prenom
        }
      })
    }

  }

}
</script>

<style lang="scss">
.comments-form {
  margin-left: -15px;
  margin-right: -15px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #dfdfdf;
  .atwho-view {
    top: 25px;
    bottom: auto;
    padding-top: 5px;
    padding-bottom: 5px;
    .atwho-li {
      font-family: "Open Sans";
      font-weight: 600;
      font-size: 13px;
      &.atwho-cur {
        background-color: #2b3085;
      }
    }
  }
  .comments-input {
    font-family: "Open Sans";
    font-size: 14px;
    margin-right: 5px;
    width: 100%;
    height: 70px;
    box-shadow: none !important;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid #2b3085;
    padding: 10px;
    overflow-y: auto;
    margin-bottom: 10px;
    &[contenteditable="true"]:empty:before {
      content: attr(placeholder);
      display: block; /* For Firefox */
      opacity: 0.5;
    }
  }
  .btn-send {
    color: #fff;
    background-color: #2b3085;
    // width: 98px;
    // height: 32px;
    white-space: nowrap;
    box-shadow: none !important;
    svg {
      margin-right: 5px;
    }
  }
}

.tagLink {
  color: #2b3085;
}

.delete-all {
  .btn {
    // background-color: red;
    // margin-bottom: 20px;
    color: #fff;
    font-family: "Open Sans";
    font-weight: 600;
  }
}

.row-btn {
  display: flex;
  justify-content: space-between;
  .btn {
    margin-bottom: 0;
    border: 1px solid #2b3085;
    color: #2b3085;
    font-size: 14px;
    border-radius: 0;
    background-color: #fff;
    height: 25px;
    line-height: 25px;
  }
}

.comment-wrapper {
  .scroll-area {
    height: 210px;
    margin-right: -15px;
    padding-right: 15px;
  }
  .ps__thumb-x, .ps__thumb-y {
    background-color: #2b3085 !important;
    width: 6px !important;
    right: 0;
    &:hover {
      background-color: #2b3085;
      width: 6px;
    }
  }
  .ps__rail-y {
    display: block;
    width: 8px;
    border: 1px solid #2b3085;
    border-radius: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/voletLaterale/commentsComponents/index.vue